import { useId, useState } from 'react';
import { useAuth } from '../lib/auth';
import { GoogleG } from './Icons';
import { Modal } from './Modal';

export function SignInDialog() {
  const { signInOpen, closeSignIn, signInWithGoogle, error, mode } = useAuth();
  const [busy, setBusy] = useState(false);
  const titleId = useId();
  const pending = signInOpen?.pending;

  const start = async () => {
    setBusy(true);
    try {
      await signInWithGoogle();
    } finally {
      // On success the page navigates away to Google; this only matters on failure.
      setBusy(false);
    }
  };

  return (
    <Modal open={Boolean(signInOpen)} onClose={closeSignIn} labelledBy={titleId}>
      <h2 id={titleId} className="disp" style={{ margin: 0, fontSize: 26, lineHeight: 1.1, fontWeight: 700, paddingRight: 40 }}>
        Sign in to save artists
      </h2>
      <p style={{ margin: '0 0 8px', fontSize: 15, lineHeight: 1.5, color: 'var(--text-2)' }}>
        {pending
          ? `${pending.name} is added as soon as you’re in. Search and albums keep working without an account.`
          : 'Save artists and get back to their albums in one click. Everything else works without an account.'}
      </p>
      {error && (
        <p className="alert" role="alert">
          {error}
        </p>
      )}
      {mode === 'demo' && (
        <p className="mono muted" style={{ margin: 0, fontSize: 12 }}>
          Demo mode: Supabase isn’t configured, so this signs in a local demo account.
        </p>
      )}
      {mode === 'off' ? (
        <p className="alert" role="alert">
          Sign-in isn’t set up on this deployment yet.
        </p>
      ) : (
        <button type="button" className="gbtn" style={{ width: '100%' }} onClick={start} disabled={busy}>
          <GoogleG />
          {busy ? 'Opening Google…' : 'Continue with Google'}
        </button>
      )}
      <button type="button" className="text-btn" onClick={closeSignIn} style={{ color: 'var(--text-2)', fontSize: 15 }}>
        Not now
      </button>
    </Modal>
  );
}
